/**
 * Copy of the app/frontend/assets/js/services/validator/ErrorCodes.js
 * that is used in ReactApp and in feature MUST BE replace to special components
 */


const ErrorCodes = {
    REQUIRED: "REQUIRED",
    WRONG_EMAIL: "WRONG_EMAIL",
    NO_RUSSIAN_MOBILE_PHONE: "NO_RUSSIAN_MOBILE_PHONE",
    NO_RUSSIAN_PHONE: "NO_RUSSIAN_PHONE",
    REQUIRED_AS_MESSAGE: "REQUIRED_AS_MESSAGE",
};

export default ErrorCodes;